var _desc, _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "https://www.w3.org/2000/svg",
    xmlnsXlink: "https://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Regular/House",
    width: 20,
    height: 20,
    fill: "#FFFFFF",
    fillOpacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.87 12.5C11.87 12.33 11.8 12.17 11.69 12.05C11.57 11.94 11.41 11.87 11.25 11.87L8.75 11.87C8.58 11.87 8.42 11.94 8.3 12.05C8.19 12.17 8.12 12.33 8.12 12.5L8.12 16.25C8.12 16.41 8.05 16.57 7.94 16.69C7.82 16.8 7.66 16.87 7.5 16.87L3.75 16.87C3.58 16.87 3.42 16.8 3.3 16.69C3.19 16.57 3.12 16.41 3.12 16.25L3.12 9.02C3.12 8.93 3.14 8.85 3.17 8.77C3.21 8.69 3.26 8.62 3.32 8.56L9.57 2.88C9.69 2.77 9.84 2.71 10 2.71C10.15 2.71 10.3 2.77 10.42 2.88L16.67 8.56C16.73 8.62 16.78 8.69 16.82 8.77C16.85 8.85 16.87 8.93 16.87 9.02L16.87 16.25C16.87 16.41 16.8 16.57 16.69 16.69C16.57 16.8 16.41 16.87 16.25 16.87L12.5 16.87C12.33 16.87 12.17 16.8 12.05 16.69C11.94 16.57 11.87 16.41 11.87 16.25L11.87 12.5Z",
    stroke: "currentColor",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/House.72e188dc15c95084f77bf5120517ecef.svg";
export { ForwardRef as ReactComponent };